import {observer} from 'mobx-react';
import React from 'react';
import ReactDOM from 'react-dom';
import {Disposers} from '../../../helpers';
import {MovableChildProvided, MovableComponentProps} from './models';
import {MovableStore} from './MovableStore';
import {passiveEventOption} from './supports-passive-events';

@observer
export class MovableImpl extends React.Component<MovableComponentProps> {
  readonly store: MovableStore;
  readonly disposers = new Disposers();

  constructor(props: Readonly<MovableComponentProps>) {
    super(props);
    this.store = new MovableStore(this);
  }

  render() {
    const props = this.props;
    const store = this.store;
    const children = this.props.children;

    const isDragging = store.isDragging;
    const movableState = isDragging ? store.state : {};

    const originalProps: MovableChildProvided = {
      movableId: props.movableId,
      isMirror: false,
      isDisabled: props.disabled === true,
      mirrorProps: {style: {}},
      isDragging: store.isDragging,
      state: movableState,
      movableProps: {ref: this.store.draggableRef},
    };

    const mirrorProps: MovableChildProvided = {
      movableId: props.movableId,
      isMirror: true,
      isDisabled: props.disabled === true,
      mirrorProps: {style: store.mirrorStyle},
      isDragging: true,
      state: movableState,
      movableProps: {}
    };

    return (<>
      {children(originalProps)}
      {
        ReactDOM.createPortal(
          isDragging ? children(mirrorProps) : null,
          document.body
        )
      }
    </>);
  }

  componentDidMount() {
    const store = this.store;
    const element = store.draggableRef.current as HTMLElement;
    if (element !== null) {
      element.addEventListener('mousedown', store.onMouseDown);
      element.addEventListener('touchstart', store.onTouchStart, passiveEventOption());
      this.disposers.add(()=>element.removeEventListener('mousedown', store.onMouseDown));
      this.disposers.add(()=>element.removeEventListener('touchstart', store.onTouchStart));
    }
  }

  componentWillUnmount() {
    this.disposers.dispose();
    this.store.dispose();
  }
}
